export default __webpack_public_path__ + "fonts/9b7438e58107275301a53cceae502fee.svg";